module.exports = __webpack_public_path__ + "images/onboarding-banner/removing-emails.caffafaeddc74296ad86.png";